const getBundleAtc = document.querySelectorAll('[data-bundle-atc]');
const getProductDetails = []; // Changed to array to allow multiple quantities
const MAX_ITEMS = 4;
const progressFill = document.querySelector('[data-progress-fill]');
const selectedCountElement = document.querySelector('[data-selected]');
const cartPriceElement = document.querySelector('[data-cart-price]');
const progressPoints = document.querySelectorAll('.bundle-progress-point');
const productBoxes = document.querySelectorAll('[data-product-box]');
const bundleTotalElement = document.querySelector('[data-bundle-total]');
const bundleSubmitButton = document.querySelector('[data-bundle-submit]');
const offerSubtitle = document.querySelector('[data-offer-subtitle]');
const quantityWrappers = document.querySelectorAll('[data-quantity-wrapper]');
// const offerBox = document.querySelector('[data-offer-box]');

// Fixed bundle price in USD
const BUNDLE_PRICE_USD = 99.99;

// Function to get current currency rate and convert bundle price
function getConvertedBundlePrice() {
  let rate = 1;
  
  // Try to get currency rate from Shopify
  if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.rate) {
    rate = parseFloat(Shopify.currency.rate);
  }
  
  // Convert bundle price to current currency
  return BUNDLE_PRICE_USD * rate;
}

// Helper function to extract currency info from a price string
function extractCurrencyInfo(priceString) {
  if (!priceString) return { symbol: '$', position: 'before' };
  
  const str = priceString.toString().trim();
  
  // Match currency symbol at the beginning
  const beforeMatch = str.match(/^([^\d\s.,]+)\s*/);
  if (beforeMatch) {
    return { symbol: beforeMatch[1], position: 'before' };
  }
  
  // Match currency symbol at the end
  const afterMatch = str.match(/\s*([^\d\s.,]+)$/);
  if (afterMatch) {
    return { symbol: afterMatch[1], position: 'after' };
  }
  
  // Default to dollar sign before
  return { symbol: '$', position: 'before' };
}

// Helper function to parse price string to number
function parsePriceValue(priceString) {
  if (!priceString) return 0;
  
  const str = priceString.toString().trim();
  
  // Extract the first numeric-looking portion so currency symbols that contain dots (e.g. "Dhs.") don't interfere
  const numericMatch = str.match(/-?\d[\d.,]*/);
  let cleanStr = numericMatch ? numericMatch[0] : str.replace(/[^\d.,-]/g, '');
  
  // Remove any leading separators that might remain (e.g. ",205")
  cleanStr = cleanStr.replace(/^[.,]+/, '');
  
  // Determine decimal separator: last separator with 1-2 digits to the right
  const lastDotIndex = cleanStr.lastIndexOf('.');
  const lastCommaIndex = cleanStr.lastIndexOf(',');
  let decimalSeparator = null;
  let decimalIndex = -1;
  
  if (lastDotIndex > lastCommaIndex) {
    const digitsAfter = cleanStr.length - lastDotIndex - 1;
    if (digitsAfter > 0 && digitsAfter <= 2) {
      decimalSeparator = '.';
      decimalIndex = lastDotIndex;
    }
  } else if (lastCommaIndex > -1) {
    const digitsAfter = cleanStr.length - lastCommaIndex - 1;
    if (digitsAfter > 0 && digitsAfter <= 2) {
      decimalSeparator = ',';
      decimalIndex = lastCommaIndex;
    }
  }
  
  let normalized = cleanStr.replace(/[.,]/g, '');
  
  if (decimalSeparator && decimalIndex !== -1) {
    const integerPart = cleanStr.slice(0, decimalIndex).replace(/[^\d-]/g, '');
    const decimalPart = cleanStr.slice(decimalIndex + 1).replace(/[^\d]/g, '');
    normalized = `${integerPart}.${decimalPart}`;
  }
  
  const value = parseFloat(normalized);
  return isNaN(value) ? 0 : value;
}

// Helper function to format price with currency
function formatPrice(amount, currencyInfo) {
  // Format number with 2 decimals
  const formattedAmount = amount.toFixed(2);
  
  // Use comma as decimal separator for currencies that typically use it
  const useComma = currencyInfo.position === 'after' || 
                   currencyInfo.symbol === '€' || 
                   currencyInfo.symbol === 'kr' ||
                   currencyInfo.symbol === 'zł' ||
                   currencyInfo.symbol === 'Kč';
  
  const displayAmount = useComma ? formattedAmount.replace('.', ',') : formattedAmount;
  
  if (currencyInfo.position === 'after') {
    return displayAmount + ' ' + currencyInfo.symbol;
  }
  return currencyInfo.symbol + displayAmount;
}

// Function to update progress bar
function updateProgressBar() {
  const selectedCount = getProductDetails.length;
  const progressPercentage = (selectedCount / MAX_ITEMS) * 100;
  
  if (progressFill) {
    progressFill.style.width = progressPercentage + '%';
  }
}

// Function to update selection count and total price
function updateSelectionDisplay() {
  const selectedCount = getProductDetails.length;
  
  // Get currency info from the first product
  const currencyInfo = getProductDetails.length > 0 
    ? extractCurrencyInfo(getProductDetails[0].price)
    : { symbol: '$', position: 'before' };
  
  // Calculate total current price (sum of current/sale prices)
  let totalCurrentPrice = 0;
  getProductDetails.forEach(product => {
    const priceValue = parsePriceValue(product.price);
    totalCurrentPrice += priceValue;
  });
  
  // Calculate total compare price (sum of original/compare at prices)
  let totalComparePrice = 0;
  getProductDetails.forEach(product => {
    if (product.comparePrice) {
      const comparePriceValue = parsePriceValue(product.comparePrice);
      totalComparePrice += comparePriceValue;
    } else {
      // If no compare price, use current price
      const priceValue = parsePriceValue(product.price);
      totalComparePrice += priceValue;
    }
  });

  console.log("product: ", getProductDetails, "totalComparePrice:: ",totalComparePrice);
  
  // Update selected count
  if (selectedCountElement) {
    selectedCountElement.textContent = selectedCount;
  }
  
  // Update total price with proper currency formatting
  if (cartPriceElement) {
    cartPriceElement.textContent = formatPrice(totalCurrentPrice, currencyInfo);
  }
  
  // Update bundle total price
  if (bundleTotalElement) {
    if (selectedCount === MAX_ITEMS) {
      // When bundle is complete, show fixed bundle price (converted to current currency) with original total (sum of compare prices) as strikethrough
      const bundlePrice = getConvertedBundlePrice(); // Fixed $99 USD converted to current currency
      const originalPrice = totalComparePrice; // Original price = sum of compare prices
      const discount = originalPrice - bundlePrice;
      console.log("originalPrice::", originalPrice, "discount: ", discount);
      bundleTotalElement.setAttribute('data-bundle-original-total', originalPrice.toFixed(2));
      bundleTotalElement.setAttribute('data-bundle-price', bundlePrice.toFixed(2));
      bundleTotalElement.setAttribute('data-bundle-discount', discount.toFixed(2));
      
      // Only show both prices if there's a discount
      if (discount > 0) {
        bundleTotalElement.innerHTML = `
          <span class="bundle-total__result">${formatPrice(bundlePrice, currencyInfo)}</span>
          <span class="bundle-total__original">${formatPrice(originalPrice, currencyInfo)}</span>
        `;
      } else {
        // If no discount, just show the bundle price
        bundleTotalElement.textContent = formatPrice(bundlePrice, currencyInfo);
      }
    } else {
      // When bundle is incomplete, show current total
      bundleTotalElement.textContent = formatPrice(totalCurrentPrice, currencyInfo);
      bundleTotalElement.removeAttribute('data-bundle-original-total');
      bundleTotalElement.removeAttribute('data-bundle-price');
      bundleTotalElement.removeAttribute('data-bundle-discount');
    }
  }
  
  // Update offer subtitle text
  updateOfferSubtitle();
  
  // Enable/disable submit button based on selection count
  updateSubmitButton();
  updateProductButtonsState();
  updateBundlePriceLabels();
}

// Function to update progress points with active class
function updateProgressPoints() {
  const selectedCount = getProductDetails.length;
  
  progressPoints.forEach((point, index) => {
    if (index < selectedCount) {
      point.classList.add('active');
    } else {
      point.classList.remove('active');
    }
  });
}

// Function to update offer subtitle text based on selected count
function updateOfferSubtitle() {
  if (!offerSubtitle) return;
  
  const selectedCount = getProductDetails.length;
  
  const messages = {
    0: "Add 4 hats to unlock bundle price",
    1: "Add 3 more hats to unlock bundle price",
    2: "Add 2 more hats to unlock bundle price",
    3: "Add 1 more hat to unlock bundle price",
    4: "Great choice! Your 4-hat bundle is ready"
  };
  
  offerSubtitle.textContent = messages[selectedCount] || messages[0];
}

// Function to enable/disable submit button and show/hide offer box
function updateSubmitButton() {
  const selectedCount = getProductDetails.length;
  const remaining = MAX_ITEMS - selectedCount;
  
  if (bundleSubmitButton) {
    if (selectedCount === MAX_ITEMS) {
      bundleSubmitButton.disabled = false;
      bundleSubmitButton.classList.add('enabled');
      bundleSubmitButton.textContent = 'Checkout';
    } else {
      bundleSubmitButton.disabled = true;
      bundleSubmitButton.classList.remove('enabled');
      
      // Update button text based on remaining products
      if (selectedCount === 0) {
        bundleSubmitButton.textContent = 'Start Bundling';
      } else if (remaining === 1) {
        bundleSubmitButton.textContent = 'Add 1 more';
      } else {
        bundleSubmitButton.textContent = `Add ${remaining} more`;
      }
    }
  }
  
  // Show/hide offer box based on selection
  // if (offerBox) {
  //   if (selectedCount === MAX_ITEMS) {
  //     offerBox.style.display = 'flex';
  //   } else {
  //     offerBox.style.display = 'none';
  //   }
  // }
}

function buildProductDataFromDataset(dataset) {
  return {
    id: dataset.bundleId || dataset.productId,
    image: dataset.variantImage,
    title: dataset.variantTitle,
    price: dataset.variantPrice,
    comparePrice: dataset.variantComparePrice || null
  };
}

function getAtcButtonByProductId(productId) {
  return document.querySelector(`[data-bundle-atc][data-bundle-id="${productId}"]`);
}

function getProductQuantity(productId) {
  return getProductDetails.filter(product => product.id === productId).length;
}

function updateQuantityDisplayForProduct(productId) {
  const wrapper = document.querySelector(`[data-quantity-wrapper][data-product-id="${productId}"]`);
  if (!wrapper) return;
  const quantityValue = wrapper.querySelector('[data-quantity-value]');
  if (quantityValue) {
    quantityValue.textContent = getProductQuantity(productId);
  }
}

function showQuantitySelector(productId) {
  const wrapper = document.querySelector(`[data-quantity-wrapper][data-product-id="${productId}"]`);
  if (wrapper) {
    wrapper.classList.remove('custom-bundle-hidden');
  }
}

function hideQuantitySelector(productId) {
  const wrapper = document.querySelector(`[data-quantity-wrapper][data-product-id="${productId}"]`);
  if (wrapper) {
    wrapper.classList.add('custom-bundle-hidden');
    const quantityValue = wrapper.querySelector('[data-quantity-value]');
    if (quantityValue) {
      quantityValue.textContent = '1';
    }
  }
}

function updateProductButtonsState() {
  const totalSelected = getProductDetails.length;
  const disableAll = totalSelected >= MAX_ITEMS;

  getBundleAtc.forEach(btn => {
    btn.disabled = disableAll;
    btn.style.opacity = disableAll ? '0.5' : '1';
    btn.style.cursor = disableAll ? 'not-allowed' : 'pointer';
  });

  quantityWrappers.forEach(wrapper => {
    const increaseBtn = wrapper.querySelector('[data-quantity-increase]');
    if (increaseBtn) {
      increaseBtn.disabled = disableAll && !wrapper.classList.contains('custom-bundle-hidden');
    }
  });
}

// to show last product as free
// function updateBundlePriceLabels() {
//   const isBundleComplete = getProductDetails.length === MAX_ITEMS;

//   productBoxes.forEach((box, index) => {
//     if (!box.classList.contains('filled')) {
//       return;
//     }

//     const priceCurrent = box.querySelector('.selected-product-box__price-current');
//     const priceCompare = box.querySelector('.selected-product-box__price-compare');
//     const product = getProductDetails[index];

//     if (!priceCurrent || !product) {
//       return;
//     }

//     if (isBundleComplete && index === getProductDetails.length - 1) {
//       priceCurrent.textContent = 'FREE';
//       priceCurrent.classList.add('selected-product-box__price-current--free');
//       if (priceCompare) {
//         priceCompare.style.display = 'none';
//       }
//     } else {
//       priceCurrent.classList.remove('selected-product-box__price-current--free');
//       priceCurrent.textContent = product.price;
//       if (priceCompare) {
//         priceCompare.style.display = '';
//       }
//     }
//   });
// }

// to show prices as it's
function updateBundlePriceLabels() {
  productBoxes.forEach((box, index) => {
    if (!box.classList.contains('filled')) {
      return;
    }

    const priceCurrent = box.querySelector('.selected-product-box__price-current');
    const priceCompare = box.querySelector('.selected-product-box__price-compare');
    const product = getProductDetails[index];

    if (!priceCurrent || !product) {
      return;
    }

    // Always show the actual price, never "FREE"
    priceCurrent.classList.remove('selected-product-box__price-current--free');
    
    // Use price directly from product object (already formatted from Shopify)
    priceCurrent.textContent = product.price;
    
    // Show compare price if available
    if (priceCompare) {
      if (product.comparePrice) {
        priceCompare.textContent = product.comparePrice;
        priceCompare.style.display = '';
      } else {
        priceCompare.style.display = 'none';
      }
    }
  });
}

function addProductToBundle(productData) {
  if (getProductDetails.length >= MAX_ITEMS) {
    updateProductButtonsState();
    return false;
  }

  const newProduct = {
    id: productData.id,
    image: productData.image,
    title: productData.title,
    price: productData.price,
    comparePrice: productData.comparePrice,
    arrayIndex: getProductDetails.length
  };

  getProductDetails.push(newProduct);
  populateProductBox(newProduct.arrayIndex, newProduct);

  updateProgressBar();
  updateProgressPoints();
  updateSelectionDisplay();

  if (getProductDetails.length === MAX_ITEMS) {
  }

  return true;
}

// Function to clear a product box back to empty state
function clearProductBox(box) {
  box.classList.remove('filled');
  box.classList.add('empty');
  box.removeAttribute('data-array-index');
  
  const emptyHTML = `
    <div class="selected-product-box__empty">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 3C8.27614 3 8.5 3.22386 8.5 3.5V8H13C13.2761 8 13.5 8.22386 13.5 8.5C13.5 8.77614 13.2761 9 13 9H8.5V13.5C8.5 13.7761 8.27614 14 8 14C7.72386 14 7.5 13.7761 7.5 13.5V9H3C2.72386 9 2.5 8.77614 2.5 8.5C2.5 8.22386 2.72386 8 3 8H7.5V3.5C7.5 3.22386 7.72386 3 8 3Z" fill="#9CA3AF"/>
      </svg>
    </div>
  `;
  
  box.innerHTML = emptyHTML;
}

// Function to populate product box with product details
function populateProductBox(index, productData) {
  const box = document.querySelector(`[data-product-box="${index}"]`);
  if (!box) return;
  
  // Remove empty state
  box.classList.remove('empty');
  box.classList.add('filled');
  box.setAttribute('data-array-index', productData.arrayIndex);
  
  // Use prices directly from productData (already formatted from Shopify)
  const displayPrice = productData.price;
  const displayComparePrice = productData.comparePrice || '';
  
  // Create product content HTML
  const productHTML = `
    <div class="selected-product-box__content">
      <img src="${productData.image}" alt="${productData.title}" class="selected-product-box__image">
      <span class="selected-product-box__remove" data-remove-index="${productData.arrayIndex}">
      <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
        <path d="M0.5 5.5L5.5 0.5M0.5 0.5L5.5 5.5" stroke="black" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      </span>
      <span class="selected-product-box__title">${productData.title}</span>
      <div class="selected-product-box__price">
        ${displayComparePrice ? `<span class="selected-product-box__price-compare">${displayComparePrice}</span>` : ''}
        <span class="selected-product-box__price-current">${displayPrice}</span>
      </div>
    </div>
  `;
  
  box.innerHTML = productHTML;
  
  // Add click event to remove button
  const removeBtn = box.querySelector(`[data-remove-index="${productData.arrayIndex}"]`);
  if (removeBtn) {
    removeBtn.addEventListener('click', () => removeProduct(productData.arrayIndex));
  }
}

// Function to rebuild all product boxes from current getProductDetails
function rebuildProductBoxes() {
  // Clear all boxes first
  productBoxes.forEach(box => {
    clearProductBox(box);
  });
  
  // Repopulate boxes with current products
  getProductDetails.forEach((product, index) => {
    populateProductBox(index, product);
  });
}

// Function to remove a product
function removeProduct(arrayIndex) {
  const removedProduct = getProductDetails[arrayIndex];
  if (!removedProduct) {
    return;
  }

  // Remove from getProductDetails array
  getProductDetails.splice(arrayIndex, 1);
  
  // Update all array indices since we removed an item
  getProductDetails.forEach((product, idx) => {
    product.arrayIndex = idx;
  });
  
  // Rebuild all boxes to maintain sequential order
  rebuildProductBoxes();
  
  // Update progress bar
  updateProgressBar();
  // Update progress points
  updateProgressPoints();
  // Update selection count and total price
  updateSelectionDisplay();

  const removedProductId = removedProduct.id;
  updateQuantityDisplayForProduct(removedProductId);

  if (getProductQuantity(removedProductId) === 0) {
    hideQuantitySelector(removedProductId);
    const bundleButton = getAtcButtonByProductId(removedProductId);
    if (bundleButton) {
      bundleButton.classList.remove('custom-bundle-hidden');
      const disableAll = getProductDetails.length >= MAX_ITEMS;
      bundleButton.disabled = disableAll;
      bundleButton.style.opacity = disableAll ? '0.5' : '1';
      bundleButton.style.cursor = disableAll ? 'not-allowed' : 'pointer';
    }
  }
  
}

getBundleAtc.forEach(item => {
  item.addEventListener('click', () => {
    const productData = buildProductDataFromDataset(item.dataset);
    const added = addProductToBundle(productData);

    if (!added) {
      return;
    }

    item.classList.add('custom-bundle-hidden');
    showQuantitySelector(productData.id);
    updateQuantityDisplayForProduct(productData.id);
  });
});

quantityWrappers.forEach(wrapper => {
  const increaseBtn = wrapper.querySelector('[data-quantity-increase]');
  const decreaseBtn = wrapper.querySelector('[data-quantity-decrease]');

  if (!increaseBtn || !decreaseBtn) {
    return;
  }

  increaseBtn.addEventListener('click', () => {
    // Rebuild product data on each click to pick up any currency conversions applied to the DOM
    const productData = buildProductDataFromDataset(wrapper.dataset);
    const added = addProductToBundle(productData);
    if (!added) {
      return;
    }
    updateQuantityDisplayForProduct(productData.id);
  });

  decreaseBtn.addEventListener('click', () => {
    const productId = wrapper.dataset.bundleId || wrapper.dataset.productId;
    const removeIndex = getProductDetails.map(product => product.id).lastIndexOf(productId);
    if (removeIndex === -1) {
      return;
    }
    removeProduct(removeIndex);
  });
});

// Handle bundle submit button click
if (bundleSubmitButton) {
  bundleSubmitButton.addEventListener('click', async () => {
    // Check if we have exactly 4 items
    if (getProductDetails.length !== MAX_ITEMS) {
      alert('Please select 4 items to complete your bundle.');
      return;
    }
    
    // Disable button and show loading state
    bundleSubmitButton.disabled = true;
    const originalText = bundleSubmitButton.textContent;
    bundleSubmitButton.textContent = 'Adding to Cart...';
    
    try {
      // Prepare items array for cart API
      const items = getProductDetails.map(product => ({
        id: product.id,
        quantity: 1
      }));
            
      // Get sections to bundle (same as theme does)
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { 
        bubbles: true, 
        detail: { sections: sectionsToBundle } 
      }));
      
      // Add all items to cart using Shopify Cart API with sections
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          items,
          sections: sectionsToBundle,
          sections_url: window.location.pathname
        })
      });
      
      if (!response.ok) {
        throw new Error('Failed to add items to cart');
      }
      
      const parsedState = await response.json();      
      // Get updated cart data with sections (same as theme does)
      const cartJson = await (await fetch('/cart.js', { ...theme.utils.fetchConfig()})).json();
      cartJson.sections = parsedState.sections;
      
      // Publish cart update using theme's pub/sub system
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { 
        source: 'custom-bundle', 
        cart: cartJson 
      });
            
      // Redirect directly to checkout after successful add
      bundleSubmitButton.textContent = 'Adding to Cart';
      window.location.href = '/checkout';
      
    } catch (error) {
      alert('There was an error adding items to cart. Please try again.');
      
      // Re-enable button
      bundleSubmitButton.disabled = false;
      bundleSubmitButton.textContent = originalText;
      updateSubmitButton(); // Restore proper state
    }
  });
}

// Mobile toggle functionality
const bundleToggle = document.querySelector('.custom-bundle__wrapper-left-toggle');
const bundleWrapper = document.querySelector('.custom-bundle__wrapper-left');

if (bundleToggle && bundleWrapper) {
  // Check if we're on mobile
  function isMobile() {
    return window.innerWidth <= 768;
  }
  
  // Initialize collapsed state on mobile
  if (isMobile()) {
    bundleWrapper.classList.add('collapsed');
  }
  
  bundleToggle.addEventListener('click', () => {
    if (isMobile()) {
      bundleWrapper.classList.toggle('collapsed');
      bundleToggle.classList.toggle('rotated');
    }
  });
  
  // Handle window resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (!isMobile()) {
        bundleWrapper.classList.remove('collapsed');
        bundleToggle.classList.remove('rotated');
      } else if (!bundleWrapper.classList.contains('collapsed')) {
        // Auto-collapse on mobile if not already
        bundleWrapper.classList.add('collapsed');
      }
    }, 250);
  });
}

// Function to initialize button states based on current selection
function initializeButtonStates() {
  updateProductButtonsState();
}

// Initialize on page load
initializeButtonStates();
updateOfferSubtitle();